export const CONTACT_INFO = {
  PHONE: '+49 172 6974288',
  EMAIL: 'info@agape-guesthouse.com',
  BOOKING_EMAIL: 'bookings@agape-guesthouse.com',
  ADDRESS: 'Άνω Βιάννος, 700 04, Greece',
  CHECK_IN_HOURS: '3:00 PM - 9:00 PM',
  GUESTHOUSE_NAME: 'Agape Community Guesthouse',
};

export const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/aXt7jh8hDUes3k1g7';

// Agape Bookings app (online reservation system) — where "Book" buttons point.
export const BOOKINGS_APP_URL =
  process.env.REACT_APP_BOOKINGS_URL || 'https://bookings.agapecrete.com';

// Accessibility overlays - controlled by environment variable (no rebuild needed)
// Set REACT_APP_ACCESSIBILITY_OVERLAYS=true in .env to enable full dark overlays for WAVE compliance
// When false or not set, uses lighter overlay for better contrast
export const ACCESSIBILITY_OVERLAYS_ENABLED = process.env.REACT_APP_ACCESSIBILITY_OVERLAYS === 'true';
